module.exports = __webpack_public_path__ + "img/195.56a272de.jpg";